module.exports = __webpack_public_path__ + "img/icon-dot.79b7e382.png";